import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-si-glyph-arrow-thin-down",
  "use": "icon-si-glyph-arrow-thin-down-usage",
  "viewBox": "0 0 17 16",
  "content": "<symbol viewBox=\"0 0 17 16\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" class=\"si-glyph si-glyph-arrow-thin-down\" id=\"icon-si-glyph-arrow-thin-down\">\n    <!-- Generator: Sketch 3.0.3 (7891) - http://www.bohemiancoding.com/sketch -->\n    <title>1161</title>\n    \n    <defs></defs>\n    <g stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\">\n        <path d=\"M9.031,15.97 L2.339,9.665 C1.88,9.206 2.043,8.505 2.245,8.306 C2.648,7.904 3.243,7.964 3.647,8.367 L8.085,12.263 L8.086,0.948 C8.087,0.436 8.512,0.022 9.038,0.021 C9.563,0.02 9.989,0.436 9.988,0.948 L10.001,12.16 L14.272,8.306 C14.676,7.904 15.331,7.904 15.733,8.306 C16.138,8.706 16.037,9.256 15.632,9.658 L9.031,15.97 L9.031,15.97 Z\" fill=\"#434343\" class=\"si-glyph-fill\" />\n    </g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/glyph/si-glyph-arrow-thin-down.svg
// module id = jvHl
// module chunks = 62